import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api, showToast, showWelcomeToast } from "@/lib/api";
import { useAuth } from "@/App";

export default function ProfileSetup() {
  const navigate = useNavigate();
  const loc = useLocation();
  const { user, refresh } = useAuth();
  const seed = loc.state?.user || user;
  const [role, setRole] = useState(seed?.role || "");
  const [username, setUsername] = useState(seed?.username || "");
  const [city, setCity] = useState(seed?.city || "Mumbai");
  const [realName, setRealName] = useState(seed?.real_name || seed?.name || "");
  const [submitting, setSubmitting] = useState(false);
  const [cities, setCities] = useState([]);

  useEffect(() => {
    api.get("/cities").then(r => setCities(r.data || []));
  }, []);

  useEffect(() => {
    if (!seed) navigate("/");
  }, [seed, navigate]);

  const submit = async () => {
    if (!role || !username || !city) {
      showToast("Please complete all fields");
      return;
    }
    setSubmitting(true);
    try {
      await api.put("/auth/me", { role, username, city, real_name: realName });
      await refresh();
      showWelcomeToast(username);
      navigate("/");
    } catch (e) {
      showToast(e?.response?.data?.detail || "Failed to save");
    } finally {
      setSubmitting(false);
    }
  };

  if (!seed) return null;

  return (
    <div style={{minHeight:"100vh",background:"#F8F7F4",display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div className="mb" style={{maxWidth:520, position:"relative", boxShadow:"0 8px 32px rgba(0,0,0,.1),0 2px 8px rgba(0,0,0,.06)"}}>
        <div className="mtitle">Welcome to LANTEN</div>
        <div className="msub">Quick setup — tell us how you'd like to participate.</div>
        <div className="ff">
          <label>I am a</label>
          <div className="role-tabs">
            <div data-testid="role-tenant" className={`rt ${role==="tenant"?"sel-t":""}`} onClick={()=>setRole("tenant")}>
              <span className="rticon">🏠</span>Tenant
            </div>
            <div data-testid="role-landlord" className={`rt ${role==="landlord"?"sel-l":""}`} onClick={()=>setRole("landlord")}>
              <span className="rticon">🔑</span>Landlord
            </div>
            <div data-testid="role-both" className={`rt ${role==="both"?"sel-b":""}`} onClick={()=>setRole("both")}>
              <span className="rticon">🏡</span>Both
            </div>
          </div>
        </div>
        <div className="ff">
          <label>Real Name</label>
          <input data-testid="profile-real-name" value={realName} onChange={(e)=>setRealName(e.target.value)} placeholder="Your full name"/>
        </div>
        <div className="ff">
          <label>Username <span style={{fontWeight:400,textTransform:"none",letterSpacing:0,fontSize:11,color:"#AEAEB2"}}>(used for posting — can differ from real name)</span></label>
          <input data-testid="profile-username" value={username} onChange={(e)=>setUsername(e.target.value.replace(/\s+/g,"_"))} placeholder="e.g. mumbai_renter_2024"/>
        </div>
        <div className="ff">
          <label>Your Primary City</label>
          <select data-testid="profile-city" value={city} onChange={(e)=>setCity(e.target.value)}>
            {cities.map(c => <option key={c.name}>{c.name}</option>)}
          </select>
        </div>
        <button data-testid="profile-save-btn" className="btn-full" disabled={submitting} onClick={submit}>
          {submitting ? "Saving…" : "Continue →"}
        </button>
      </div>
    </div>
  );
}
